import { render, staticRenderFns } from "./AlertSnackbar.vue?vue&type=template&id=04f11ccf&"
import script from "./AlertSnackbar.vue?vue&type=script&lang=js&"
export * from "./AlertSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports